import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/dev/prototypes")({
	component: PrototypesLayout,
});

function PrototypesLayout() {
	return <Outlet />;
}
